<app-complex-modal-template
    [isConfirmationMode]="false"
    [title]="titleKey | transloco">
    <div class="p-4">
        <p class="whitespace-pre-line">
            {{ descriptionKey | transloco }}
        </p>

        <p class="mt-4 text-sm text-custom-dark-grey">
            {{
                'editMode.storage.usage'
                    | transloco
                        : {
                              estimatedQuota: storageUsageParams.estimatedQuota,
                              percentUsed: storageUsageParams.percentUsed,
                              usedStorage: storageUsageParams.usedStorage,
                          }
            }}
        </p>

        @if (data.hasMultipleEditSessions) {
            <p class="mt-4">
                {{ 'editMode.storage.multiSessionWarning' | transloco }}
            </p>
        }

        <div class="flex justify-end gap-2 mt-4">
            <app-button
                [label]="'cancel' | transloco"
                [type]="ButtonType.SECONDARY"
                (click)="cancel()" />

            <app-button
                [label]="'editMode.submit.save' | transloco"
                [type]="ButtonType.PRIMARY"
                (onClick)="save()" />

            @if (data.canClearHistory) {
                <app-button
                    [label]="'editMode.storage.clearHistory.action' | transloco"
                    [type]="ButtonType.ALERT_SECONDARY"
                    (onClick)="clearHistory()" />
            }
        </div>
    </div>
</app-complex-modal-template>
